'use client';

import { useRef } from 'react';
import { Provider } from 'react-redux';

import { AppStore, RootState, setupStore } from '@app/store';

export default function StoreProvider({
  children,
  preloadedState
}: {
  children: React.ReactNode;
  preloadedState?: Partial<RootState>;
}) {
  const storeRef = useRef<AppStore>();
  if (!storeRef.current) {
    storeRef.current = setupStore(preloadedState);
  }

  return <Provider store={storeRef.current}>{children}</Provider>;
}
